const HOURS_PREFIX = `location-details-hours`

export const hoursHeapAttributes = {
  hoursBusinessTab: `${HOURS_PREFIX}-business-tab`,
  hoursBusinessRegularTab: `${HOURS_PREFIX}-business-weekly-tab`,
  hoursBusinessRegularEditButton: `${HOURS_PREFIX}-business-weekly-edit-button`,
  hoursBusinessRegularCancelButton: `${HOURS_PREFIX}-business-weekly-cancel-button`,
  hoursBusinessRegularSaveButton: `${HOURS_PREFIX}-business-weekly-save-button`,
  hoursBusinessRegularEmptyCreateButton: `${HOURS_PREFIX}-business-weekly-empty-create-button`,

  hoursBusinessHolidayTab: `${HOURS_PREFIX}-business-holiday-tab`,
  hoursBusinessHolidayEditButton: `${HOURS_PREFIX}-business-holiday-edit-button`,
  hoursBusinessHolidayCancelButton: `${HOURS_PREFIX}-business-holiday-cancel-button`,
  hoursBusinessHolidaySaveButton: `${HOURS_PREFIX}-business-holiday-save-button`,
  hoursBusinessHolidayDeleteButton: `${HOURS_PREFIX}-business-holiday-delete-button`,
  hoursBusinessHolidayEmptyCreateButton: `${HOURS_PREFIX}-business-holiday-empty-create-button`,

  hoursBusinessTempCloseTab: `${HOURS_PREFIX}-business-temp-close-tab`,
  hoursBusinessTempCloseSaveButton: `${HOURS_PREFIX}-business-temp-close-save-button`,

  hoursSpecialtyTab: `${HOURS_PREFIX}-specialty-tab`,
  hoursSpecialtyRegularTab: `${HOURS_PREFIX}-specialty-weekly-tab`,
  hoursSpecialtyRegularHourType: `${HOURS_PREFIX}-specialty-weekly-add-hour-type-button`,
  hoursSpecialtyRegularHourTypeOption: `${HOURS_PREFIX}-specialty-weekly-hour-type-option`,
  hoursSpecialtyRegularEditButton: `${HOURS_PREFIX}-specialty-weekly-edit-button`,
  hoursSpecialtyRegularCancelButton: `${HOURS_PREFIX}-specialty-weekly-cancel-button`,
  hoursSpecialtyRegularSaveButton: `${HOURS_PREFIX}-specialty-weekly-save-button`,
  hoursSpecialtyRegularDeleteButton: `${HOURS_PREFIX}-specialty-weekly-delete-button`,
  hoursSpecialtyRegularEmptyCreateButton: `${HOURS_PREFIX}-specialty-weekly-empty-create-button`,

  hoursSpecialtyHolidayTab: `${HOURS_PREFIX}-specialty-holiday-tab`,
  hoursSpecialtyHolidayHourType: `${HOURS_PREFIX}-specialty-holiday-add-hour-type-button`,
  hoursSpecialtyHolidayHourTypeOption: `${HOURS_PREFIX}-specialty-holiday-hour-type-option`,
  hoursSpecialtyHolidayEditButton: `${HOURS_PREFIX}-specialty-holiday-edit-button`,
  hoursSpecialtyHolidayCancelButton: `${HOURS_PREFIX}-specialty-holiday-cancel-button`,
  hoursSpecialtyHolidaySaveButton: `${HOURS_PREFIX}-specialty-holiday-save-button`,
  hoursSpecialtyHolidayDeleteButton: `${HOURS_PREFIX}-specialty-holiday-delete-button`,
  hoursSpecialtyHolidayEmptyCreateButton: `${HOURS_PREFIX}-specialty-holiday-empty-create-button`,

  hoursSpecialtyTempCloseTab: `${HOURS_PREFIX}-specialty-temp-close-tab`,
  hoursSpecialtyTempCloseHourType: `${HOURS_PREFIX}-specialty-temp-close-add-hour-type-button`,
  hoursSpecialtyTempCloseHourTypeOption: `${HOURS_PREFIX}-specialty-temp-close-hour-type-option`,
  hoursSpecialtyTempCloseEditButton: `${HOURS_PREFIX}-specialty-temp-close-edit-button`,
  hoursSpecialtyTempCloseCancelButton: `${HOURS_PREFIX}-specialty-temp-close-cancel-button`,
  hoursSpecialtyTempCloseSaveButton: `${HOURS_PREFIX}-specialty-temp-close-save-button`,

  hoursMultipleSaveModalSaveButton: `${HOURS_PREFIX}-multiple-save-modal-save-button`,
  hoursMultipleSaveModalCancelButton: `${HOURS_PREFIX}-multiple-save-modal-cancel-button`,
} as const
